import templateStr from 'text!./note-view.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            note: '=',
            showTopic: '='
        },
        controller: ['$scope', 'InsuranceSuiteMetadata', function ($scope, InsuranceSuiteMetadata) {
            if (angular.isDefined($scope.showTopic)) {
                $scope.topic = InsuranceSuiteMetadata.get('pc').types.getTypelist('NoteTopicType').getCode($scope.note.topic);
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/NoteViewDirective/NoteView.js
// module id = 1750
// module chunks = 0